import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ththreshold from '../entities/ththreshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface ThthresholdState extends ListState<Ththreshold>{
    editThthreshold:Ththreshold
}
class UserMutations extends ListMutations<Ththreshold>{

}
class ThthresholdModule extends ListModule<ThthresholdState,any,Ththreshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Ththreshold>(),
        loading:false,
        editThthreshold:new Ththreshold()
    }
    actions={
        async getPage(context:ActionContext<ThthresholdState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThThreshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Ththreshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<ThthresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/ThThreshold/Create',payload.data);
        },
        async update(context:ActionContext<ThthresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/ThThreshold/Update',payload.data);
        },
        async delete(context:ActionContext<ThthresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThThreshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<ThthresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThThreshold/GetById?Id='+payload.id);
            return reponse.data.result as Ththreshold;
        }
    };
    mutations={
        setCurrentPage(state:ThthresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:ThthresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:ThthresholdState,ththreshold:Ththreshold){
            
            state.editThthreshold=ththreshold;
            //console.log(state.editFloor);
        }
    }
}
const ththresholdModule=new ThthresholdModule();
export default ththresholdModule;